var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.909,
    height: 15.909,
    viewBox: "0 0 15.909 15.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    transform: "translate(2.121 2.121)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_316",
    "data-name": "Line 316",
    x2: 11.666,
    y2: 11.666,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#f52424",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    x1: 11.666,
    y2: 11.666,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#f52424",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCloseIcon);
export default __webpack_public_path__ + "static/media/redCloseIcon.52331e5129cc832dc70ad3d5a787e84c.svg";
export { ForwardRef as ReactComponent };